/* eslint-disable */
import React, { memo, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import { Grid } from "react-loader-spinner";
import { grayColor } from "assets/jss/material-dashboard-pro-react";

const useStyles = makeStyles({
  wrapper: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 10,
  },
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "calc(100vh - 175px)",
    width: "100%",
    backgroundColor: grayColor[11],
    borderRadius: "8px",
  },
  containerFocusMode: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    width: "100%",
    backgroundColor: grayColor[11],
    borderRadius: "8px",
  },
  label: {
    fontSize: "14px",
    color: grayColor[0],
    marginBottom: "16px",
  },
  exiting: {
    animation: "$fadeOut 200ms ease-out forwards",
  },
  "@keyframes fadeOut": {
    "0%": { opacity: 1 },
    "100%": { opacity: 0 },
  },
});

/**
 * LoadingPlaceholder component
 *
 * Displays a full-area placeholder while page data is loading.
 * Visually matches the initial session loading spinner (gray background,
 * centered Grid spinner with a descriptive label).
 *
 * When onExitComplete is provided the component plays a fade-out
 * animation and then calls the callback so the parent can unmount it.
 */
function LoadingPlaceholder({ clientColor, onExitComplete, focusMode = false }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    if (onExitComplete) {
      const exitTimer = setTimeout(() => {
        setIsExiting(true);
      }, 50);
      return () => clearTimeout(exitTimer);
    }
  }, [onExitComplete]);

  useEffect(() => {
    if (isExiting && onExitComplete) {
      const completeTimer = setTimeout(() => {
        onExitComplete();
      }, 200);
      return () => clearTimeout(completeTimer);
    }
  }, [isExiting, onExitComplete]);

  return (
    <div className={`${classes.wrapper} ${isExiting ? classes.exiting : ""}`}>
      <div
        className={
          focusMode ? classes.containerFocusMode : classes.container
        }
      >
        <span className={classes.label}>
          {t("alignment_session.loading_page")}
        </span>
        <Grid width={40} height={40} color={clientColor} />
      </div>
    </div>
  );
}

LoadingPlaceholder.propTypes = {
  clientColor: PropTypes.string,
  onExitComplete: PropTypes.func,
  focusMode: PropTypes.bool,
};

LoadingPlaceholder.defaultProps = {
  clientColor: null,
  onExitComplete: null,
  focusMode: false,
};

export default memo(LoadingPlaceholder);
